module.exports = __webpack_public_path__ + "static/media/usa.4a6bd16c.png";